import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

export const BASE_URL = `${Config.api.document.url}api/v1/opportunities`;

class OpportunityDocumentsService {
  getDocument({ opportunityId, documentId, cancelToken = null }) {
    return ApiService.get(`${BASE_URL}/${opportunityId}/documents/${documentId}`, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }

  getDocumentFile({ opportunityId, documentId, cancelToken = null }) {
    return ApiService.get(`${BASE_URL}/${opportunityId}/documents/${documentId}/file`, {
      responseType: 'blob',
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }

  // All the opportunity's documents as a single .zip.
  getAllDocumentFiles({ opportunityId, cancelToken = null }) {
    return ApiService.get(`${BASE_URL}/${opportunityId}/documents/download`, {
      responseType: 'blob',
      headers: { Accept: 'application/octet-stream' },
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }

  getDocumentForms({ opportunityId, cancelToken = null }) {
    return ApiService.get(`${BASE_URL}/${opportunityId}/documents/form-fills`, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }
  getDocumentForm({ opportunityId, formFillId, cancelToken = null }) {
    return ApiService.get(`${BASE_URL}/${opportunityId}/documents/form-fills/${formFillId}`, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }

  // The filled output file (bytes) for a document form record.
  getDocumentFormFile({ opportunityId, formFillId, cancelToken = null }) {
    return ApiService.get(`${BASE_URL}/${opportunityId}/documents/form-fills/${formFillId}/file`, {
      responseType: 'blob',
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }

  // Download all form-fill outputs for an opportunity as a single .zip.
  getAllDocumentFormFiles({ opportunityId, cancelToken = null }) {
    return ApiService.get(`${BASE_URL}/${opportunityId}/documents/form-fills/download`, {
      responseType: 'blob',
      headers: { Accept: 'application/octet-stream' },
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }

  getOpportunityPdfEngineMatchInformation({ opportunityId, cancelToken = null }) {
    return ApiService.get(`${BASE_URL}/${opportunityId}/pdf-engine/match-information`, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }

  searchContent({ opportunityId, query, cancelToken = null }) {
    return ApiService.get(`${BASE_URL}/${opportunityId}/documents/search?q=${encodeURIComponent(query)}`, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }

  getDocumentQueue({ opportunityId, cancelToken = null }) {
    return ApiService.get(`${BASE_URL}/${opportunityId}/documents/queue`, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }

  deleteDocument({ opportunityId, documentId }) {
    return ApiService.delete(`${BASE_URL}/${opportunityId}/documents/${documentId}`).then((response) => response.data);
  }

  getDeletionImpact({ opportunityId, documentId, cancelToken = null }) {
    return ApiService.get(`${BASE_URL}/${opportunityId}/documents/${documentId}/deletion-impact`, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }

  // Upload new opportunity documents. Pass type=FORM to upload known forms
  // directly (no classification/extraction is triggered).
  addDocuments({ opportunityId, formData, type = null }) {
    return ApiService.post(`${BASE_URL}/${opportunityId}/documents`, formData, {
      params: type ? { type } : undefined,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    }).then((response) => response.data);
  }
}

export const opportunityDocumentsService = new OpportunityDocumentsService();
